import type React from "react";

interface BlockquoteProps {
  children: React.ReactNode;
}

export function Blockquote({ children }: BlockquoteProps): React.ReactNode {
  return (
    <blockquote className="my-space-sm border-l-4 border-l-border-secondary bg-background-secondary p-space-md text-body-emphasis">
      {children}
    </blockquote>
  );
}
